// extracted by mini-css-extract-plugin
export default {"switch":"LyFxs","switchDisabled":"dXuNO","field":"uKMgp","body":"fuz3d","toggle":"EJe1U"};